import { Loading, Tab, TabPanels, Tabs, TabsList } from '@octano/global-ui';
import { useCallback } from 'react';
import { useParams } from 'react-router';
import { useWarningsSummaryDetailsFormLoaderData } from '../loaders/StudentWarningsSummaryDetailsFormLoader';
import { useWarningsSummaryDetailsLoader } from '../loaders/StudentWarningsSummaryDetailsLoader';

import {
  StudentWarningsGroupType,
  StudentWarningsSummaryDetailsParams,
} from '../types';
import StudentWarningsSummaryDetailsSwitch from './StudentWarningsSummaryDetailsSwitch';

const StudentWarningsSummaryTabs = () => {
  const params = useParams<StudentWarningsSummaryDetailsParams>();
  const data = useWarningsSummaryDetailsFormLoaderData();
  const {
    result,
    query,
    updateQuery,
    loading,
  } = useWarningsSummaryDetailsLoader();

  const handleChangeTab = useCallback(
    (tab: string | number) => {
      updateQuery({
        ...query,
        warningGroupType: tab as StudentWarningsGroupType,
      });
      window.history.replaceState(
        null,
        '',
        `/student-warnings/details/${query.studyPlanEnrollmentId}/${query.periodId}/${query.year}/${tab}`,
      );
    },
    [query, updateQuery],
  );

  if (loading && !result?.success) {
    return (
      <div className="w-100 d-flex flex-wrap justify-content-center">
        <Loading textBody={''} />
      </div>
    );
  }

  return (
    <div className="w-100">
      <Tabs defaultTab={params.warningGroupType} onSelection={handleChangeTab}>
        <TabsList>
          {data?.warningGroups.map((group) => (
            <Tab id={group.value} key={group.value}>
              {group.label}
            </Tab>
          ))}
        </TabsList>
        <TabPanels>
          <StudentWarningsSummaryDetailsSwitch />
        </TabPanels>
      </Tabs>
    </div>
  );
};

export default StudentWarningsSummaryTabs;
